<app-flow-action-card icon="live_help" iconColor="text-teal-600" label="Ga naar vraag">
  <div flowCardActions>
    <button
      mat-icon-button
      (click)="panToNode.emit(data().value)"
      matTooltip="Spring naar vraag"
      class="inline-flex! size-6! p-1!"
    >
      <mat-icon class="size-4! text-base/4! font-medium!">my_location</mat-icon>
    </button>
  </div>

  @if (questionLabel(); as label) {
    <span
      class="inline-block align-middle"
      [innerHTML]="label | highlightVariables"
    ></span>
  }
</app-flow-action-card>
